const standardColors = {
  White: '#FFFFFF',
  Background: '#F9FAFA',
  Action: '#009FDA',
  Primary_120: '#002341',
  Primary_100: '#003755',
  Primary_70: '#406980',
  Primary_50: '#7F9BAA',
  Primary_30: '#BFCDD4',
  Primary_10: '#E5EBEE',
  PrimaryB_100: '#D7E9F1',
  PrimaryB_70: '#E0EEF5',
  PrimaryB_50: '#E7F1F7',
  PrimaryB_30: '#F0F7FA',
  PrimaryB_10: '#F7FAFC',
  Info_100: '#6DBACE',
  Info_80: '#8BC5D7',
  Info_60: '#A8D2E0',
  Info_40: '#C3E0EB',
  Info_20: '#E0EEF4',
  Info_10: '#EFF6F9',
  Alert_100: '#E65A6D',
  Alert_80: '#EB7C83',
  Alert_60: '#EF9A9C',
  Alert_40: '#F4BAB8',
  Alert_20: '#F9DAD8',
  Alert_10: '#FCECEA',
  Caution_100: '#FFE17F',
  Caution_80: '#FFE698',
  Caution_60: '#FFECB0',
  Caution_40: '#FFF3CA',
  Caution_20: '#FFF9E2',
  Caution_10: '#FFFBF0',
  Success_100: '#09B89D',
  Success_80: '#5EC3AE',
  Success_60: '#8AD0BF',
  Success_40: '#B2DFD3',
  Success_20: '#D6EDE7',
  Success_10: '#EAF6F3',
  Alt_100: '#74489D',
  Alt_80: '#8865AC',
  Alt_60: '#9F84BD',
  Alt_40: '#BAA7D1',
  Alt_20: '#D9D0E7',
  Alt_10: '#EBE6F2',
  Attention_100: '#FBB273',
  Attention_80: '#FCC18B',
  Attention_60: '#FDCFA5',
  Attention_40: '#FEDDBF',
  Attention_20: '#FEEEDC',
  Attention_10: '#FEF6ED',
  GreyA_100: '#7B8185',
  GreyA_80: '#93989C',
  GreyA_60: '#ABAFB2',
  GreyA_40: '#C5C8CB',
  GreyA_20: '#E0E2E3',
  GreyA_10: '#EFF0F1',
  GreyB_100: '#E7E3DD',
  GreyB_80: '#EBE8E4',
  GreyB_60: '#F0EEEA',
  GreyB_40: '#F6F4F2',
  GreyB_20: '#FAFAF8',
  GreyB_10: '#FCFBFB',
  GreyC_100: '#C7CECB',
  GreyC_80: '#D2D7D5',
  GreyC_60: '#DBE0DE',
  GreyC_40: '#E8EBEA',
  GreyC_20: '#F3F5F4',
  GreyC_10: '#F9FAFA',
  GreyD_100: '#3A4344',
  GreyD_80: '#5E676A',
  GreyD_60: '#7F898B',
  GreyD_40: '#A6ADB0',
  GreyD_20: '#D0D4D6',
  GreyD_10: '#E6E8E9',
};

export default standardColors;
